
import { useSyncExternalStore } from 'react';











export const wideQuery = typeof window !== 'undefined' ? window.matchMedia('(min-width: 1021px)') : null;

export function useWide() {
  return useSyncExternalStore(
    (cb) => { wideQuery?.addEventListener('change', cb); return () => wideQuery?.removeEventListener('change', cb); },
    () => wideQuery?.matches ?? false,
  );
}
